var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#2FAC66","d":"M5.046,0C2.264,0,0,2.264,0,5.046c0,1.101,0.348,2.147,1.007,3.025l3.729,5.022\r\n\t\t\tc0.009,0.012,0.024,0.017,0.034,0.028c0.186,0.2,0.455,0.149,0.588-0.028c1.074-1.433,3.042-4.108,3.799-5.118l0.001-0.001\r\n\t\t\tl0.005-0.006c0.61-0.857,0.932-1.867,0.932-2.922C10.093,2.264,7.829,0,5.046,0z M5.046,7.769c-1.498,0-2.722-1.224-2.722-2.722\r\n\t\t\ts1.224-2.722,2.722-2.722s2.722,1.224,2.722,2.722S6.545,7.769,5.046,7.769z"}))));
}

Location.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"10.093px","height":"13.25px","viewBox":"0 0 10.093 13.25","enableBackground":"new 0 0 10.093 13.25","xmlSpace":"preserve"};

module.exports = Location;

Location.default = Location;
